// extracted by mini-css-extract-plugin
module.exports = {"songBar":"styles_songBar__2mY4L","appear":"styles_appear__26AsB","container":"styles_container__14k6u","subContainer":"styles_subContainer__19mri","title":"styles_title__2aVfh"};